<template>
  <div class="test_list_wrap" v-loading="loading">
    <div class="teacher_test_list_table" v-if="userType==0||userType==1">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :height="height"
        :header-cell-style="headerCellStyle"
        class="collegeTable"
        :empty-text="empty"
      >
        <el-table-column prop="paperName" label="考试名称"></el-table-column>
        <el-table-column label="总分">
          <template slot-scope="scope">
            <span>{{scope.row.totalScore.split(".")[0]}}分/{{scope.row.totalQuestion}}题</span>
          </template>
        </el-table-column>
        <el-table-column prop="examTime" label="考试时长"></el-table-column>
        <el-table-column prop="examCount" label="考试时间">
        	<template slot-scope="scope">
	      		{{scope.row.examStartTime.substring(0,10)}}~{{scope.row.examEndTime.substring(0,10)}}
	      	</template>
        </el-table-column>
        <el-table-column prop="notSumbit" label="未提交" width="100"></el-table-column>
        <el-table-column prop="sumbit" label="已提交" width="100"></el-table-column>
        <el-table-column label="平均分" width="100">
        	<template slot-scope="scope">
            <span>{{scope.row.average}}分</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <el-button @click.native.prevent="previewRow(scope.$index, tableData)" round size="small">预览</el-button>
            <el-button @click.native.prevent="seeRow(scope.row)" round size="small">查看</el-button>
            <el-button @click.native.prevent="publishAnswer(scope.row)" round size="small" v-if="scope.row.answerStatus == 0 && scope.row.answerPublishStatus == 0">公布答案</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="student_test_list_table" v-if="userType==2||userType==3" :style="'height:'+(height+50)+'px'">
      <ul v-if="tableData.length>0" :style="'height:'+(height-5)+'px'">
        <li v-for="(item, i) in tableData" :key="i">
         	<div class="left">
         		<p>【{{item.paperName}}】</p>
         		<div class="bottom">
         			<span class="exam">{{item.totalScore.split(".")[0]}}分/{{item.totalQuestion}}题</span>
         			<span>考试时间：{{item.examStartTime.substring(0,10)}}——{{item.examEndTime.substring(0,10)}}</span>
         			<span>考试时长：{{item.examTime}}分钟</span>
         			<span :class="handleExamStatus(item.examStatus,3)"><img :src="handleExamStatus(item.examStatus,2)"/>{{handleExamStatus(item.examStatus,1)}}</span>
         		</div>
         	</div>
         	<div class="btn">
         		<el-button v-if="item.userPaperStatus == 'answerDetail'" @click="answerDetails(item)" :disabled="item.buttonStatus == 0?true:false">作答详情</el-button>
	          <el-button class="answer" v-if="item.userPaperStatus=='continueQuestion'" @click="giveResponse(item.userPaperStatus,item,false)">继续作答</el-button>
	          <el-button class="answer" v-if="item.userPaperStatus=='startQuestion'" @click="giveResponse(item.userPaperStatus,item)" :disabled="item.buttonStatus == 0?true:false">开始考试</el-button>
	          <!--<el-button class="marg0" v-if="item.userPaperStatus1=='againQuestion'" @click="giveResponse(item.userPaperStatus,item)">重做一遍</el-button>-->
	          <el-button disabled v-if="item.userPaperStatus=='notSubmit'">未提交</el-button>
         	</div>
        </li>
      </ul>
      <div v-else class="no_list">
        <img src="../../../../../../static/images/wujieguo.png"/>
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
	import * as api from "../../../../../api/examinationApi";
export default {
  data() {
    return {
      loading: true,
      height: window.innerHeight - 90+'px', // 表格高度根据窗口高度来决定
      tableData: [],
      empty: "暂无数据",
      userType: sessionStorage.getItem('userType')
    };
  },
  created() {
    this.getTestList();
  },
  methods: {
    getTestList(){
      let courseId = this.$route.query.id;
      let classId = this.$route.query.classId;
      if(this.userType==0||this.userType==1){
        api.getTeacherExam(courseId,classId).then(rs=>{
	        if(rs.code==0){
    				this.loading = false
	          this.tableData = rs.data
	        }else{
	          this.$messageError(rs.mag)
	        }
	      }).catch(err=>{
	        console.log(err)
	      })
      }else{
      	let userId = sessionStorage.getItem('userId');
        api.getStudentExam(courseId,userId,classId).then(rs=>{
	        if(rs.code==0){
	          this.tableData = rs.data
	        }else{
	          this.$messageError(rs.mag)
	        }
	      }).catch(err=>{
	        console.log(err)
	      })
      }
      this.loading = false
    },
    // 表格头部样式
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 ){
        return "background:rgba(83,151,247,0.1);color:#999999;";
      }
    },
    previewRow(index,rows){
      const { href } = this.$router.resolve({
        path: '/switch/test/preview',
        query: {
          paperId: rows[index].id,
          id: this.$route.query.id,
          classId: this.$route.query.classId,
          className:this.$route.query.className
        }
      });
      window.open(href, '_blank');
    },
    seeRow(row){
      // this.wrapStatus = false
      this.$router.push({
        path: "/switch/examination/detailsPage",
        query: {
          id: this.$route.query.id,
          paperId: row.id,
          paperName: row.paperName,
          markingWay: row.markingWay,
          classId: this.$route.query.classId,
					className: this.$route.query.className,
          total: row.totalQuestion,
          type:1,
          finishFlag:1
        }
      })
    },
    // 公布答案
    publishAnswer(row){
    	this.$tipsDialog(
				"提示",
    		"公布答案后学生可查看考试答案和解析，且不可撤回，确定公布答案吗？",
		    "",
		    "el-icon-warning",
		    "rgb(255, 178, 60)"
			).then(() => {
				api.publishAnswer(row.examId).then(res=>{
	    		if(res.code == 0){
	    			this.getTestList();
	    		}else{
	    			this.$messageError(rs.mag)
	    		}
	    	})
     	}).catch(() => {});
    },
    // 开始作答/继续作答
    giveResponse(status,item,flag){
			//跳转到考试系统
      api.ifIntoExam(this.$route.query.id,item.paperId,this.$route.query.classId).then(res=>{
      	if(res.code == 0 || res.code == 1){
    			const { href } = this.$router.resolve({
		        path: "/switch/test/testPaper",
		        query: {
		          id: this.$route.query.id,
		          paperId:item.paperId,
		          catalogId:item.catalogId,
		          paperCode:item.paperCode,
		          total:item.totalQuestion,
		          className:this.$route.query.className,
		          paperName:item.paperName,
		          paperScore:item.totalScore,
		          count:item.totalQuestion,
		          examTestType:1,
		          resourceId:item.paperId,
              classId: this.$route.query.classId,
              type:1,
              examId:item.examId,
              finishFlag:1,
              flag:false
		        }

		      });
          window.open(href, '_blank');
          setTimeout(()=>{
            this.getTestList()
          },5000)
      	}else if(res.code == 2){
    			this.$messageError('答案还未公布，无法查看作答详情');
    			return;
    		}else if(res.code == 3) {
      		const { href } = this.$router.resolve({
		        path: '/switch/test/stupreview',
		        query: {
		          id: this.$route.query.id,
		          paperId: item.paperId,
              finishFlag:1,
              type:1
		        }
		      });
          window.open(href, '_blank');
          setTimeout(()=>{
            this.getTestList()
          },5000)
    		}else if(res.code == 4){
    			this.$messageError(res.mag)
    		}
      }).catch(err=>{
        console.log(err)
      })
    },
    // 作答详情
    answerDetails(row){
      console.log(row.examId)
    	const { href } = this.$router.resolve({
        path: '/switch/test/stupreview',
        query: {
          id: this.$route.query.id,
          paperId: row.paperId,
          classId: this.$route.query.classId,
          userId:sessionStorage.getItem('userId'),
          className:this.$route.query.className,
          finishFlag:1,
          type:1,
          examId:row.examId
        }
      });
      window.open(href, '_blank');
    },
    // 学生端处理考试状态
    handleExamStatus(status,num){
    	let str = '';
    	let src = '';
    	let className = '';
    	switch (status){
    		case 0:
    			str = '未开始'
    			src = '../../../../../../static/images/study/icon/weikaishi.png'
    			className = 'nostarted'
    			break;
    		case 1:
    			str = '进行中'
    			src = '../../../../../../static/images/study/icon/inProgress.png'
    			className = 'beginning'
    			break;
    		case 2:
    			str = '已结束'
    			src = '../../../../../../static/images/study/icon/completed.png'
    			className = 'ending'
    			break;
    		case 3:
    			str = '已交卷'
    			src = '../../../../../../static/images/study/icon/success.png'
    			className = 'submit'
    			break;
    		default:
    			break;
    	}
    	if(num == 1){
    		return str
    	}else if(num == 2){
    		return src
    	}else if(num == 3){
    		return className
    	}
    },
  },
}
</script>

<style lang="scss" scoped>
.test_list_wrap {
  padding: 16px;
  background: #F4F4F4;
  height: 100%;
  .test_list_header {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  .teacher_test_list_table {
    padding-bottom: 16px;
    .collegeTable {
      border: 1px solid #ebebeb;
      border-radius: 4px;
      box-sizing: border-box;
    }
    /deep/ .el-button--small,.el-button--small.is-round {
      padding: 5px 15px;
      color: #5397f7;
    }
    /deep/ .el-table__empty-text {
      display: block;
      width: 200px;
      height: 200px;
      padding-top: 190px;
      color: #909399;
      box-sizing: border-box;
      background: url('../../../../../../static/images/wujieguo.png');
      background-size: 100% 100%;
    }
  }
  .student_test_list_table {
    padding: 16px;
    background: #fff;
    height: 100%;
    ul{
      overflow-y: auto;
      li{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height:80px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(230,230,230,1);
        border-radius:4px;
        padding: 14px 24px 14px 14px;
        box-sizing: border-box;
        margin-top: 8px;
        margin-bottom: 8px;
        &:hover{
          box-shadow:0px 3px 12px rgba(83,151,247,0.67);
        }
        .left {
        	display: flex;
        	flex-direction: column;
        	justify-content: space-between;
        	height: 100%;
        	width: calc(100% - 300px);
        	p {
        		color: #333333;
        		font-size: 16px;
        		font-weight: bold;
        		margin-left: -7px;
        	}
        	.bottom {
        		display: flex;
        		align-items: center;
        		justify-content: space-between;
        		span {
        			display: flex;
        			align-items: center;
        			font-size: 14px;
        			color: #333333;
        			img {
        				display: inline-block;
        				width: 16px;
        				height: 16px;
        				margin-right: 4px;
        			}
        		}
        		.exam {
        			display: inline-block;
        			width: 100px;
        		}
        		.ending {
        			color: #5397F7;
        		}
        		.nostarted {
        			color: #FF785A;
        		}
        		.beginning {
        			color: #FFB23C;
        		}
            .submit{
              color: #6de2a2;
            }
        	}
        }
        .el-button{
          width:96px;
          height:34px;
          background:rgba(83,151,247,1);
          border-radius:4px;
          font-size:14px;
          font-weight:400;
          color:rgba(255,255,255,1);
          padding: 0;
          margin-right: 14px;
          &:hover{
            background:rgba(42,119,227,1);
          }
        }
        .el-button.is-disabled {
        	background: #CCCCCC;
        	color: #FFFFFF;
        }
      }
    }
    .no_list{
      padding-top: 100px;
      text-align: center;
      img{
        // width: 100px;
      }
      p{
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/examination/index.vue